var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AWS from 'aws-sdk';
import { b64D } from './helpers';
const aK = window.thk.custAK;
const sK = window.thk.custSK;
const dS = b64D(sK);
const dA = b64D(aK);
AWS.config.update({
    region: 'ap-southeast-2',
    credentials: new AWS.Credentials(dA, dS),
});
export const s3 = new AWS.S3({ apiVersion: '2006-03-01' });
export const ryanAI = (uploadedFile, sessionID) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch('https://b3tsia65il.execute-api.ap-southeast-2.amazonaws.com/prod/remove-bg-transparent-background', {
        method: 'POST',
        headers: {
            'Content-Type': 'image/jpeg',
            'x-session-id': sessionID,
        },
        body: uploadedFile,
    });
    if (response.ok) {
        const data = yield response.json();
        return data.url;
    }
    else {
        console.error('Error:', response.status, yield response.text());
    }
});
